// SEO metadata is now managed centrally by <Seo /> (src/components/Seo.js) using src/seo/routes.json.
// This hook is kept as a no-op so existing page components keep working without duplicate meta tags.
export function usePageMeta() {}
